import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VENDOR_BIDS_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorMyDemandBidsTable from './components/VendorMyDemandBidsTable';
import VendorOtherDemandBidsTable from './components/VendorOtherDemandBidsTable';

const VendorDemandBids = () => {
  const [activeTab, setActiveTab] = useState(VENDOR_BIDS_TABS.MY_DEMAND);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[VENDOR_BIDS_TABS.MY_DEMAND, VENDOR_BIDS_TABS.OTHER_DEMAND]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab mb-3"
        />
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={VENDOR_BIDS_TABS.MY_DEMAND}>
          {activeTab === VENDOR_BIDS_TABS.MY_DEMAND && (
            <ErrorBoundary>
              <VendorMyDemandBidsTable />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={VENDOR_BIDS_TABS.OTHER_DEMAND}>
          {activeTab === VENDOR_BIDS_TABS.OTHER_DEMAND && (
            <ErrorBoundary>
              <VendorOtherDemandBidsTable />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default VendorDemandBids;
